import { useState } from "react";

const useTimestamp = () => {
  const [timestamp, setTimestamp] = useState(Date.now());

  return [timestamp, () => setTimestamp(Date.now())];
};

export default useTimestamp;
